import React from 'react';
import { Dir } from 'modules/dirs';
import { Select, MenuItem, makeStyles } from '@material-ui/core';
import { Theme } from 'theme';
import dirsConfig from 'config/dirs';
import { useDirsActions } from 'modules/dirs/hooks';
import { useTranslation } from 'utils/translation';
import { applyFilters } from '../../../../../core';

interface Props {
  dir: Dir;
}

const useStyles = makeStyles((theme: Theme) => ({
  select: {
    fontSize: theme.spacing(1.75)
  },
  option: {
    fontSize: theme.spacing(1.75)
  }
}));

const DirectoryType: React.FC<Props> = ({ dir }) => {
  const classes = useStyles();
  const { t } = useTranslation('myDisk');
  const { pathUpdateDir } = useDirsActions();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    pathUpdateDir({
      id: dir.id,
      directoryType: event.target.value as string
    });
  };

  const availableTypes = applyFilters(
    'available_directory_types',
    dirsConfig.types
  );

  return (
    <div>
      <Select
        className={classes.select}
        disableUnderline
        id="directory-type"
        value={dir.directoryType || ''}
        onChange={handleChange}>
        {Object.keys(availableTypes).map(type => (
          <MenuItem key={type} value={type} className={classes.option}>
            {t(dirsConfig.types[type])}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export { DirectoryType };
